import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { DebtCollectionLog } from './debt-collection-log';
import { DebtCollectionPaymentUpdate } from './debt-collection-payment-update';

export class DebtCollection extends ModelBase {
  agencyErrandId: string;
  createdAt: LocalDate;
  amount: Money;
  company: number;
  invoiceNumber: number;
  invoiceRecipient: string;
  invoiceAmount: Money;
  unpaidInvoiceAmount: Money;
  paymentUpdates: DebtCollectionPaymentUpdate[];
  invoiceRefersToPeriod: string;
  invoiceDueDate: LocalDate;
  externalSystemName: string;
  debtCollectionLogs: DebtCollectionLog[];
}
